<template>
	<v-flex class="xs12 sm12 px-sm-2 mt-4">
		<v-file-input
			:label="label"
			outlined
			dense
			v-model="localAttachment"
			show-size
			:error-messages="messageFieldError(fieldName)"
			@change="updateAttachment"
		></v-file-input>

		<v-alert
			v-if="localAttachment && localAttachment.size > maxFileSize.max_file_size_b"
			dense
			outlined
			type="warning"
			class="m-0 mb-2 error-alert"
		>
			You uploaded the file larger than {{ maxFileSize.max_file_size_mb }} MB.
		</v-alert>

		<v-alert
			dense
			outlined
			type="warning"
			class="m-0 error-alert"
		>
			Accepted Formats: DOC(X), GIF, JPG, PDF, PNG, TXT, XLS(X);
			{{ maxFileSize.warning }}
		</v-alert>
	</v-flex>
</template>

<script>
import maxFileSizeMixin from "../../mixins/files/maxFileSize";

export default {
	name: "FileUploader",
	mixins: [maxFileSizeMixin],
	props: {
		attachment: {
			validator: (value) => value === null || value instanceof File,
			default: null
		},
		fieldName: {
			type: String,
			required: true
		},
		label: {
			type: String,
			default: "File Input"
		}
	},
    created() {
        this.loadMaxFileSize('files');
    },
	computed: {
		localAttachment: {
			get() {
				return this.attachment;
			},
			set(value) {
				this.$emit("update:attachment", value instanceof File ? value : null);
			}
		}
	},
	methods: {
		updateAttachment(value) {
			this.$emit("update:attachment", value instanceof File ? value : null);
		}
	}
};
</script>
